import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanListLoadBoundComponent } from './plan-list-load-bound.component';

@NgModule({
  declarations: [PlanListLoadBoundComponent],
  imports: [CommonModule],
  exports: [PlanListLoadBoundComponent],
})
export class PlanListLoadBoundModule {}
